import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Box,
  Typography,
  CircularProgress,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { axiosInstance } from "src/services/config";
import { ServicesURL } from "@utils/utilsApi";

interface CertificatePreviewModalProps {
  open: boolean;
  onClose: () => void;
  html: string;
  orientation: string;
}

const CertificatePreviewModal: React.FC<CertificatePreviewModalProps> = ({
  open,
  onClose,
  html,
  orientation,
}) => {
  const [pdfUrl, setPdfUrl] = useState<string | null>(null);
  const [pdfLoading, setPdfLoading] = useState(false);
  const [pdfError, setPdfError] = useState<string | null>(null);

  useEffect(() => {
    if (!open || !html) return;

    setPdfLoading(true);
    setPdfError(null);

    if (pdfUrl) {
      URL.revokeObjectURL(pdfUrl);
      setPdfUrl(null);
    }

    axiosInstance
      .post(
        ServicesURL.previewCertificatePdf,
        { html },
        { responseType: "blob" },
      )
      .then((response: any) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const url = URL.createObjectURL(blob);
        setPdfUrl(url);
      })
      .catch(() => {
        setPdfError("Errore nella generazione della preview PDF");
      })
      .finally(() => {
        setPdfLoading(false);
      });
  }, [open, html]);

  useEffect(() => {
    if (!open && pdfUrl) {
      URL.revokeObjectURL(pdfUrl);
      setPdfUrl(null);
    }
  }, [open]);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={false}
      PaperProps={{
        sx: {
          width: "90vw",
          maxWidth: "90vw",
          height: "90vh",
          maxHeight: "90vh",
          display: "flex",
          flexDirection: "column",
        },
      }}
    >
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          pb: 1,
        }}
      >
        <Box>
          Preview Certificato
          <Typography variant="caption" sx={{ ml: 2, color: "text.secondary" }}>
            {orientation}
          </Typography>
        </Box>
        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent
        sx={{
          flex: 1,
          overflow: "hidden",
          display: "flex",
          flexDirection: "column",
          p: 0,
        }}
      >
        {pdfLoading ? (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flex: 1,
            }}
          >
            <CircularProgress />
          </Box>
        ) : pdfError ? (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flex: 1,
            }}
          >
            <Typography color="error">{pdfError}</Typography>
          </Box>
        ) : pdfUrl ? (
          <iframe
            src={pdfUrl}
            style={{
              width: "100%",
              height: "100%",
              border: "none",
              flex: 1,
            }}
            title="certificate-preview-pdf"
          />
        ) : null}
      </DialogContent>
    </Dialog>
  );
};

export default CertificatePreviewModal;
